// The ticket card in the support panel (support plan, 26 Oct: "hand over to a
// person"). Shown once the agent has filed a ticket on this call: the reference,
// who gets back to the caller, and inside office hours a button to WhatsApp
// Thomas with the reference already typed in.
import { MessageCircle, Ticket } from 'lucide-react'
import type { HandoverTicket } from '@/lib/supportHandover'

export function SupportTicketCard({ ticket }: { ticket: HandoverTicket }) {
  return (
    <section aria-label="Your support ticket" aria-live="polite"
      className="surface border hairline-strong rounded-2xl p-3 flex flex-col gap-2">
      <p className="flex items-center gap-2 text-sm font-semibold text-fg">
        <Ticket size={16} className="text-emerald-400" aria-hidden="true" /> Ticket {ticket.ref}
      </p>
      <p className="text-sm text-fg-muted">
        {ticket.callback ? 'Thomas or Jason will call you back.' : 'Thomas or Jason will get back to you.'}
      </p>
      {ticket.whatsapp && (
        <a href={ticket.whatsapp} target="_blank" rel="noopener noreferrer"
          className="btn-primary tap-target-y inline-flex items-center justify-center gap-2 rounded-full">
          <MessageCircle size={16} aria-hidden="true" /> WhatsApp Thomas now
        </a>
      )}
    </section>
  )
}
